import { Grid, GridProps } from '@mui/material';
import * as React from 'react';
import { useTheme } from 'styled-components';
import { IColProps } from '../Col';

interface IRowContext extends IColProps {}

export interface IRowProps extends IColProps { isUnderMarketplacePage ?: boolean; }

export const RowContext = React.createContext<IRowContext | undefined>(
  undefined
);

/**
 * Hook which exposes `IRowContext` for state consumption and updates
 */
export const useRowContext = (): IRowContext => {
  const context = React.useContext(RowContext);
  if (!context) {
    throw new Error('This component must be used within a < Row > component.');
  }
  return context;
};

const Row: React.FC<IRowProps & GridProps> = ({ children, isUnderMarketplacePage = false, ...style }) => {
  const theme = useTheme();
  return (
    <Grid container spacing={isUnderMarketplacePage ? theme.marketplaceGridSpacing : theme.gridSpacing} {...(style as GridProps)}>{children}</Grid>
  );
};

Row.displayName = 'Row';

export default Row;
